import React from "react";
import {
  LeftArrowPagination,
  RightArrowPagination,
} from "../../assets/icons/icons";
import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";

const itemsPerPageOptions = [
  { value: "", label: "Select" },
  { value: 10, label: "10" },
  { value: 25, label: "25" },
  { value: 50, label: "50" },
  { value: 100, label: "100" },
];

export default function Pagination({
  currentPage,
  totalPages,
  onPageChange,
  pagination,
  setItemsPerPage,
}) {
  const [searchParams, setSearchParams] = useSearchParams();

  const handlePrevPage = () => {
    if (currentPage > 1) onPageChange(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) onPageChange(currentPage + 1);
  };

  const generatePageNumbers = () => {
    const pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else if (currentPage <= 3) {
      for (let i = 1; i <= 5; i++) {
        pages.push(i);
      }
    } else if (currentPage >= totalPages - 2) {
      for (let i = totalPages - 4; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      for (let i = currentPage - 2; i <= currentPage + 2; i++) {
        pages.push(i);
      }
    }
    return pages;
  };
  const handleItemsPerPageChange = (event) => {
    const value = parseInt(event.target.value, 10);

    setItemsPerPage(value);
    setSearchParams((prev) => {
      prev.set("pagination", value);
      prev.set("page", 1);
      onPageChange(1);
      return prev;
    });
  };

  useEffect(() => {
    const pagination = parseInt(searchParams.get("pagination"), 10);

    if (pagination) {
      setItemsPerPage(pagination);
    }
  }, [searchParams, setItemsPerPage, pagination]);
  return (
    <div className="flex items-center space-x-2">
      <button
        onClick={handlePrevPage}
        disabled={currentPage === 1}
        aria-label="Previous Page"
        className={`h-8 w-8 rounded border ${
          currentPage === 1
            ? "border-gray-300 text-gray-400"
            : "border-[#0075FF] text-[#0075FF]"
        } flex cursor-pointer items-center justify-center`}
      >
        <LeftArrowPagination />
      </button>

      {generatePageNumbers().map((page) => (
        <button
          key={page}
          onClick={() => onPageChange(page)}
          className={`cursor-pointer rounded-[6px] border px-[12px] py-[6px] text-center font-outfit text-[16px] font-normal leading-[20.16px] ${
            page === currentPage
              ? "bg-[#0075FF] text-[#FFFFFF]"
              : "border-[#DDDDDD] text-[#666666]"
          }`}
        >
          {page}
        </button>
      ))}

      <button
        onClick={handleNextPage}
        disabled={currentPage === totalPages}
        aria-label="Next Page"
        className={`h-8 w-8 rounded border ${
          currentPage === totalPages
            ? "border-gray-300 text-gray-400"
            : "border-blue-500 text-blue-500"
        } flex cursor-pointer items-center justify-center`}
      >
        <RightArrowPagination />
      </button>

      {/* Dropdown for selecting items per page */}
      <select
        value={pagination}
        onChange={handleItemsPerPageChange}
        className="ml-4 h-10 rounded border border-gray-300 p-2"
      >
        {itemsPerPageOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}
